<template>
  <v-form ref="form" v-model="valid">
    <v-card>
      <v-container>
        <v-card-title>휴가 추가부여</v-card-title>
        <v-card-text>
          <v-select
            v-model="data.empList"
            :items="empLists"
            :rules="[rules.required]"
            item-value="empNo"
            item-text="empNm"
            multiple
            label="대상자"
          ></v-select>
          <v-text-field
            v-model.number="data.day"
            :rules="[rules.required]"
            label="추가부여일"
            hint="숫자만 입력가능"
          ></v-text-field>
          <v-textarea v-model="data.note" label="비고"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="onCancel">취소</v-btn>
          <v-btn color="green darken-1" text @click="onSubmit">저장</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-form>
</template>

<script>
export default {
  data() {
    return {
      valid: true,
      data: {
        day: null,
        empList: null,
        note: null,
      },
      rules: {
        required: value => !!value || "필수 항목입니다.",
      },
    };
  },
  props: ["isShow", "empLists"],
  watch: {
    isShow(newVal) {
      if (!newVal) {
        this.reset();
      }
    },
  },
  mounted() {
    this.reset();
  },
  methods: {
    reset() {
      this.$refs.form.resetValidation();
      Object.assign(this.$data, this.$options.data());
    },
    async onSubmit() {
      this.$refs.form.validate();
      if (!this.valid) return false;
      this.$emit("addVacation", this.data);
    },
    onCancel() {
      this.reset();
      this.$emit("hideModal");
    },
  },
};
</script>

<style></style>
